import React from "react";
import "../News/News.css";

const News = () => {
  return (
    <section className="news-section">
      <div className="news-content">
        <div className="news-text">
          <h2>JOIN THE NEWSLETTER</h2>
          <p>
            Subscribe to our newsletter and get <strong>10% off</strong> your first purchase
          </p>
        </div>
        <div className="news-input">
          <input
            type="email"
            placeholder="Enter your email"
            className="email-input"
          />
          <button className="subscribe-button">SUBSCRIBE</button>
        </div>
      </div>
    </section>
  );
};

export default News;
